/**
 * The offset every in-page `#fragment` has to clear, now that the chrome
 * above it can change height.
 *
 * The sticky header was a fixed number of pixels until the import promise
 * ribbon joined it (§27b). The ribbon can be dismissed, so that number is no
 * longer a constant — and a `scrollMarginTop` hard-coded to include it would
 * drop every anchor 40px too low for the visitor who closed it.
 *
 * So the ribbon publishes its own height as a CSS variable and the anchors
 * add it. `var(..., 0px)` falls back to zero, which is what the one place
 * that renders without the ribbon — the root error boundary — needs, and
 * what any future page outside `SiteLayout` gets for free.
 */

/** Set on `:root` by `ImportPromiseRibbon`; zero once the ribbon is dismissed. */
export const PROMISE_BAR_HEIGHT_VAR = '--kbx-promise-bar-h';

const clear = (px: number) => `calc(${px}px + var(${PROMISE_BAR_HEIGHT_VAR}, 0px))`;

/**
 * `scrollMarginTop` for an element a `#fragment` points at.
 *
 * The two defaults are the header's real height at each breakpoint — 88 on a
 * phone, 120 from md up — which is what every call site was already using
 * before the ribbon existed.
 */
export const anchorOffsetSx = (xs = 88, md = 120) => ({
  scrollMarginTop: { xs: clear(xs), md: clear(md) },
});
